// @flow
import { type SearchBucketDTO, SearchValueType } from "data/types";
import loc from "i18next";

// inPoint.Forms/Controls/Search/Search/SearchViewModel.cs
const GetDefaultSearchBuckets = (): Array<SearchBucketDTO> => [
    {
        visible: true,
        icon: "fa-regular fa-clock",
        name: "Geaendert_am",
        caption: loc.t("common:filter.Geaendert_am.name"),
        valueType: SearchValueType.RelativeDate,
        selected: [],
        buckets: [
            {
                value: "Today",
                caption: loc.t("common:filter.RelativeDate.Today"),
            },
            {
                value: "Yesterday",
                caption: loc.t("common:filter.RelativeDate.Yesterday"),
            },
            {
                value: "ThisWeek",
                caption: loc.t("common:filter.RelativeDate.ThisWeek"),
            },
            {
                value: "ThisMonth",
                caption: loc.t("common:filter.RelativeDate.ThisMonth"),
            },
            {
                value: "LastMonth",
                caption: loc.t("common:filter.RelativeDate.LastMonth"),
            },
            {
                value: "ThisYear",
                caption: loc.t("common:filter.RelativeDate.ThisYear"),
            },
            {
                value: "LastYear",
                caption: loc.t("common:filter.RelativeDate.LastYear"),
            },
        ],
    },
    {
        visible: true,
        icon: "fa-regular fa-calendar",
        name: "Erstellt_am",
        caption: loc.t("common:filter.Erstellt_am.name"),
        valueType: SearchValueType.RelativeDate,
        selected: [],
        buckets: [
            {
                value: "Today",
                caption: loc.t("common:filter.RelativeDate.Today"),
            },
            {
                value: "Yesterday",
                caption: loc.t("common:filter.RelativeDate.Yesterday"),
            },
            {
                value: "ThisWeek",
                caption: loc.t("common:filter.RelativeDate.ThisWeek"),
            },
            {
                value: "ThisMonth",
                caption: loc.t("common:filter.RelativeDate.ThisMonth"),
            },
            {
                value: "LastMonth",
                caption: loc.t("common:filter.RelativeDate.LastMonth"),
            },
            {
                value: "ThisYear",
                caption: loc.t("common:filter.RelativeDate.ThisYear"),
            },
            {
                value: "LastYear",
                caption: loc.t("common:filter.RelativeDate.LastYear"),
            },
        ],
    },
    {
        visible: true,
        icon: "fa-regular fa-floppy-disk",
        name: "Groesse",
        caption: loc.t("common:filter.Groesse.name"),
        valueType: SearchValueType.FileSize,
        hideName: true,
        selected: [],
        buckets: [
            { value: "Empty", caption: loc.t("common:filter.FileSize.Empty") },
            { value: "Tiny", caption: loc.t("common:filter.FileSize.Tiny") },
            { value: "Small", caption: loc.t("common:filter.FileSize.Small") },
            {
                value: "Medium",
                caption: loc.t("common:filter.FileSize.Medium"),
            },
            { value: "Large", caption: loc.t("common:filter.FileSize.Large") },
            { value: "Huge", caption: loc.t("common:filter.FileSize.Huge") },
            {
                value: "VeryHuge",
                caption: loc.t("common:filter.FileSize.VeryHuge"),
            },
        ],
    },
];

export default GetDefaultSearchBuckets;
